// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKompanive_containerDashboardP__nLQuK","mobileResponsive":"TabelaEKompanive_mobileResponsive__404Pk"};